"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";

const CAPABILITIES = [
  { id: "opsAnalysis", shot: "/images/home/2-21.jpg" },
  { id: "adStrategy", shot: "/images/home/2-22.jpg" },
  { id: "aPlus", shot: "/images/home/2-23.jpg" },
  { id: "productVideo", shot: "/images/home/2-24.jpg" },
  { id: "alerts", shot: "/images/home/2-25.jpg" },
  { id: "workflow", shot: "/images/home/2-26.jpg" },
] as const;

export function HomeCapabilityTabs({ brand }: { brand: string }) {
  const t = useTranslations("site.homePage.capabilities");
  const [active, setActive] = useState(0);
  const current = CAPABILITIES[active];

  return (
    <section className="shouye-liaojie" aria-labelledby="shouye-liaojie-title">
      <div className="w1440 shouye-liaojie__inner">
        <h2 id="shouye-liaojie-title" className="shouye-liaojie__title">
          {t("title", { brand })}
        </h2>

        <div className="shouye-liaojie__tags">
          <div className="shouye-liaojie__tags-track" role="tablist">
            {CAPABILITIES.map((item, index) => (
              <div key={item.id} className="shouye-liaojie__tag-cell">
                <button
                  type="button"
                  role="tab"
                  id={`shouye-liaojie-tab-${index}`}
                  aria-selected={index === active}
                  aria-controls="shouye-liaojie-panel"
                  className={`shouye-liaojie__tag${
                    index === active ? " shouye-liaojie__tag--active" : ""
                  }`}
                  onClick={() => setActive(index)}
                >
                  {t(`tabs.${item.id}`)}
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="shouye-liaojie__panels">
          <div
            className="shouye-liaojie__panel"
            role="tabpanel"
            id="shouye-liaojie-panel"
            aria-labelledby={`shouye-liaojie-tab-${active}`}
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              className="shouye-liaojie__shot"
              src={current.shot}
              alt={t("previewAlt", { label: t(`tabs.${current.id}`) })}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
